export class AuthenticationInfo {
  constructor(
    public username: string,
    public firstName: string,
    public lastName: string,
    public isAdministrator: boolean,
    public customerId: string,
    public groups: string[]
  ) {}
}
